/**
 * @generated SignedSource<<c762dbade46973324e1e0cf24d1b2cdf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCompleted_charge$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkCompleted_charge">;
  readonly " $fragmentType": "PaymentCompleted_charge";
};
export type PaymentCompleted_charge$key = {
  readonly " $data"?: PaymentCompleted_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCompleted_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCompleted_charge",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkCompleted_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "ac995af2be61c22b3f7a524f0f6b171a";

export default node;
